<template>
  <div class="content">
    <div class="build-CURD">
      <!-- <div class="build-bar head-title">
        合肥经开区各在建项目人员返回信息登记表
      </div> -->
      <div class="build-bar flex-wrap yiqing" style="padding:10px;height:auto;">
        <p style="padding:10px 20px;font-size:20px;margin:0;background: #17b2fe;border-radius: 5px;cursor: pointer;border: 1px solid #0695dc;margin-right:20px;color:#fff;" @click="showAllFun">总人数：{{num.allNum}}</p>
        <p style="padding:10px 20px;font-size:20px;margin:0;background: #17b2fe;border-radius: 5px;cursor: pointer;border: 1px solid #0695dc;margin-right:20px;color:#fff;" @click="showBackFun">外出返岗人数：{{num.holidayOutNum}}</p>
        <p style="padding:10px 20px;font-size:20px;margin:0;background: #17b2fe;border-radius: 5px;cursor: pointer;border: 1px solid #0695dc;margin-right:20px;color:#fff;" @click="showFailFun">三类重点人群：{{num.isolateNum}}</p>
        <el-button type="primary" class="add-user" @click="exportOut">导出报表</el-button>
        <!-- <el-form label-position="right" label-width="100px" style="text-align: left;">
        <el-form-item label="来源地" style="display:inline-block;">
          <el-select v-model="search.comeProvince" clearable placeholder="不限">
            <el-option
              v-for="item in provinces"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交通方式"   style="display:inline-block;">
          <el-select v-model="search.trafficTools" clearable placeholder="不限">
            <el-option
              v-for="item in traffics"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员类型"   style="display:inline-block;">
          <el-select v-model="search.workType" clearable placeholder="不限">
            <el-option
              v-for="item in workerTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无不适症状"   style="display:inline-block;">
          <el-select v-model="search.isNotSick" clearable placeholder="不限">
            <el-option
              v-for="item in isNotSicks"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无接触特殊区域/人员"   style="display:inline-block;">
          <el-select v-model="search.isNotContact" clearable placeholder="不限">
            <el-option
              v-for="item in isNotContacts"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="体温"   style="display:inline-block;">
          <el-select v-model="search.backTemperature" clearable placeholder="不限">
            <el-option
              v-for="item in backTemperatures"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称"   style="display:inline-block;">
          <el-input placeholder="请输入项目名称" v-model="search.name"></el-input>
        </el-form-item>
        <el-form-item label="" style="display:inline-block;">
          <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin:0;">查询</el-button>
          <el-button type="primary" class="add-user" @click="exportOut">导出报表</el-button>
        </el-form-item>
        </el-form> -->
      </div>
      <div class="build-table">
        <el-table
          :data="listData"
          border
          height="100%"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column
            label="序号"
            width="60">
            <template slot-scope="scope">
              <a>{{ scope.row.index}}</a>
            </template>
          </el-table-column>
          <!-- <el-table-column label="项目名称">
            <template slot-scope="scope">
              <a>{{ scope.row.groupName}}</a>
            </template>
          </el-table-column> -->
          <el-table-column label="姓名" width="80px">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="性别" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.sex=='1'">男</span>
              <span v-else>女</span>
            </template>
          </el-table-column>
          <el-table-column label="年龄" width="80px">
            <template slot-scope="scope">
              <span>{{ scope.row.age }}</span>
            </template>
          </el-table-column>
          <el-table-column label="人员性质" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.workType=='0'">其他</span>
              <span v-if="scope.row.workType=='1'">建设单位</span>
              <span v-if="scope.row.workType=='2'">施工单位</span>
              <span v-if="scope.row.workType=='3'">监理单位</span>
              <span v-if="scope.row.workType=='4'">设计单位</span>
              <span v-if="scope.row.workType=='5'">勘察单位</span>
            </template>
          </el-table-column>
          <el-table-column label="春节假期有无外出情况">
            <template slot-scope="scope">
              <span v-if="scope.row.holidayOut=='0'">有</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="籍贯">
            <template slot-scope="scope">
              <span>{{ scope.row.comeProvinceName+scope.row.comeCityName+scope.row.comeAreaName }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="是否与疫情人员接触">
            <template slot-scope="scope">
              <span v-if="scope.row.isNotContact=='1'" style="color:red;">有</span>
              <span v-else>无</span>
            </template>
          </el-table-column> -->
          <el-table-column label="与疫情人员接触是否隔离">
            <template slot-scope="scope">
              <span v-if="scope.row.isNotIsolate=='0'" style="color:red;">已隔离</span>
              <span v-else>未隔离</span>
            </template>
          </el-table-column>
          <el-table-column label="体温">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.phone }}</span> -->
              <span v-if="!scope.row.overTemperature" style="color:red;">{{scope.row.backTemperature}}℃</span>
              <span v-else>{{scope.row.backTemperature}}℃</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="出发地">
            <template slot-scope="scope">
              <span>{{ scope.row.startingPoint }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="交通工具" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.trafficTools=='1'">自驾或拼车</span>
              <span v-else-if="scope.row.trafficTools=='2'">飞机</span>
              <span v-else-if="scope.row.trafficTools=='3'">火车</span>
              <span v-else-if="scope.row.trafficTools=='4'">船舶</span>
              <span v-else-if="scope.row.trafficTools=='5'">长途汽车</span>
              <span v-else>其他</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="车辆车牌号、火车车次及车厢号座位号航班号及座位号、公交车线路">
            <template slot-scope="scope">
              <span>{{ scope.row.toolName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">健康档案</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页展示 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../../untils/port'
import base from '../../../../untils/base'
import util from '../../../../untils/util'
export default {
  data() {
    return {
      search:{  //查询
        name:'',//项目名称
        groupId:'',//项目id
        groupType:'1',//1,项目、2，企业
        //areaId:'',//区域id
        //projectType:'1',//项目类型  1：房建   2：市政
        comeProvince:'',//省份（来源地）
        trafficTools:'',//交通方式
        holidayOut:'',//是否外出
        // updateDate:util.myTime.getCurTime(),
        workType:'',//岗位
        isNotSick:'',//生病
        isNotContact:'',//有无接触特殊区域/人员
        backTemperature:'',//体温
      },
      listData:[], //表格数据
      //selectedOptions:["1162316774055600129", "1162316774160457730", "1175657805877567490"],//所选的区域
      areas:[],//区域
      flags:[
        {id:'1',name:'房建'},
        {id:'2',name:'市政'}
      ],
      provinces:[],//省份列表
      traffics:[    //交通方式列表
        {id:'0',name:'自驾'},
        {id:'1',name:'飞机'},
        {id:'2',name:'火车'},
        {id:'3',name:'船舶'},
        {id:'4',name:'长途汽车'}
      ],
      workerTypes:[       //岗位类别   0管理，1工人
        {id:"0",name:'管理人员'},
        {id:"1",name:'工人'},
      ],
      isNotSicks:[      //生病  
        {id:'1',name:'有'},
        {id:'2',name:'无'},
      ],
      isNotContacts:[     //有无接触特殊区域/人员
        {id:'1',name:'有'},
        {id:'2',name:'无'},
      ],
      backTemperatures:[    //体温异常  
        {id:'0',name:'正常'},
        {id:'1',name:'异常'},
      ],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      entId:'',
      port:'',
      num:{},//统计数量
      flag:'0',
      dataText:'数据加载中...',
    }
  },
  mounted(){
    // this.entId = this.$store.state.groupId;
    // if(''==this.entId){
    //   this.$store.commit('setGroupId');
    //   this.entId = this.$store.state.groupId;
    // }
    // this.getCurArea();
    this.port = util.session.get('roleId')
    if(this.$route.params.id=='0'&&this.port=='4'){
        this.search.groupId = util.session.get('groupId')
    }else{
        this.search.groupId = this.$route.params.id;
    }
    // this.search.groupId = this.$route.params.id;
    this.getData()
    this.getNum()
    //this.getArea();//获取所有区域
    //this.getProvice();//获取省份
    // this.uploadData.userId = this.$store.state.user.id;
    // this.uploadData.entId = this.entId;
    // this.getOfficeList();
  },
  methods: {
    // 搜索数据
    doFilter() {
      //this.search.areaId = this.selectedOptions[this.selectedOptions.length-1];
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    //获取所属区域
    // getCurArea(){
    //   var that = this;
    //   myHttp.getSuperviseById({id:this.entId}).then(function(resp){
    //     if(resp.data.code=="200"){
    //       that.search.areaId = resp.data.data.supervise.areaId;
    //       that.getData();
    //     }
    //   },function(){});
    // },
    // 获取数据
    getData() {
      var that = this;
      this.search.pageNum = this.currentPage;
      this.search.pageSize = this.pageSize;
      myHttp.getBackPersonBygroupId(this.search).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.BackPersonList.list||[];
            for(var i=0;i<list.length;i++){
              list[i].index = that.pageSize*(parseInt(that.currentPage)-1)+(i+1);
              list[i].overTemperature = parseFloat(list[i].backTemperature)>37.3?false:true
              list[i].comeProvinceName = list[i].comeProvinceName?list[i].comeProvinceName:'';
              list[i].comeCityName = list[i].comeCityName?list[i].comeCityName:'';
              list[i].comeAreaName = list[i].comeAreaName?list[i].comeAreaName:'';
            }
            that.listData = list;
            that.totalItems = resp.data.data.BackPersonList.total||0;
            if(that.listData.length==0){
                that.dataText = "暂无数据"
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText = "暂无数据"
        }
      },function(){});
    },
    //导出
    exportOut(){
      var token = this.$store.state.token;
      //window.open(myHttp.exportProjectAndBackPerson+'?areaId='+this.search.areaId+'&name='+this.search.name+'&accessToken='+token+'&workType='+this.search.workType+'&isNotSick='+this.search.isNotSick+'&isNotContact='+this.search.isNotContact+'&backTemperature='+this.search.backTemperature+'&trafficTools='+this.search.trafficTools+'&comeProvince='+this.search.comeProvince+'&updateDate='+this.search.updateDate);
      if(this.flag == '0'){
        window.open(myHttp.exportBackWorkByProj+'?accessToken='+token+'&groupId='+this.search.groupId+'&groupType='+this.search.groupType);
      }else if(this.flag == '1'){
        window.open(myHttp.exportBackWorkByHolidayOut+'?accessToken='+token+'&groupId='+this.search.groupId+'&groupType='+this.search.groupType);
      }else if(this.flag == '2'){
        window.open(myHttp.exportBackWorkByThreeKind+'?accessToken='+token+'&groupId='+this.search.groupId+'&groupType='+this.search.groupType);
      }
    },
    /**
     * 获取统计数据
     */
    getNum(){
      let that = this
      myHttp.getStatisBackPerson({
        groupId:this.search.groupId,
        groupType:this.search.groupType
      }).then(function(resp){
        if(resp.data.code=="200"){
            that.num = resp.data.data.personNumber;
        }else{
          that.$message.error(resp.data.msg);
        }
      });
    },
    //获取区域
    getArea(){
      var that = this;
      myHttp.getAreaList().then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.areaList;
          var tree = util.common.listToTree('id','parentId',list);
          that.areas = tree;
        }else{
            that.$message.error(resp.data.msg);
        }
      },function(){});
    },
    /**
     * 获取省份
     */
    getProvice(){
      var that = this;
      myHttp.getProvince().then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.provinceList;
          that.provinces = list;
        }else{
            that.$message.error(resp.data.msg);
        }
      },function(){});
    },
    //查看
    handleEdit(index,row){
      //this.$router.push({name:'personInfo',params:{id:row.personId}})
      this.$router.push({name:'personInfo',params:{id:row.id,groupId:row.groupId}})
    },
    //监听区域
    selcetKu(data){

    },
    //监听类型
    selcetFlag(data){

    },
    /**
     * 展示所有的人员
     */
    showAllFun(){
      // this.search.isFever = '';
      // this.search.isCaugh = '';
      // this.search.isFatigue = '';
      // this.search.isNotContact = '';
      // this.search.backTemperature = '';
      // this.search.holidayOut = '';
      this.flag = '0'
      this.getData();
    },
    /**
     * 展示外地返岗人员
     */
    showBackFun(){
      // this.search.isFever = '';
      // this.search.isCaugh = '';
      // this.search.isFatigue = '';
      // this.search.isNotContact = '';
      // this.search.backTemperature = '';
      // this.search.holidayOut = '0';
      // this.getData();
      this.flag = '1'
      this.currentPage = 1
      let that = this
      myHttp.getBackPersonByHolidayOut({
        pageNum :this.currentPage,
        pageSize :this.pageSize,
        groupId:this.search.groupId,
        groupType:this.search.groupType,
        holidayOut:'0'
      }).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.BackPersonList.list||[];
            for(var i=0;i<list.length;i++){
              list[i].index = that.pageSize*(parseInt(that.currentPage)-1)+(i+1);
              list[i].overTemperature = parseFloat(list[i].backTemperature)>37.3?false:true
              list[i].comeProvinceName = list[i].comeProvinceName?list[i].comeProvinceName:'';
              list[i].comeCityName = list[i].comeCityName?list[i].comeCityName:'';
              list[i].comeAreaName = list[i].comeAreaName?list[i].comeAreaName:'';
            }
            that.listData = list;
            that.totalItems = resp.data.data.BackPersonList.total||0;
        }else{
          that.$message.error(resp.data.msg);
        }
      });
    },
    /**
     * 展示三种重点人员
     */
    showFailFun(){
      // this.search.isFever = '0';
      // this.search.isCaugh = '0';
      // this.search.isFatigue = '0';
      // this.search.isNotContact = '1';
      // this.search.backTemperature = '37.4';
      // this.search.holidayOut = '';
      this.flag = '2'
      this.currentPage = 1
      // this.getData();
      let that = this
      myHttp.getBackPersonBySick({
        pageNum :this.currentPage,
        pageSize :this.pageSize,
        groupId:this.search.groupId,
        groupType:this.search.groupType,
        isFever:'0',
        isCaugh:'0',
        isFatigue:'0',
        isNotContact:'1',
        backTemperature:'37.4',
      }).then(function(resp){
        if(resp.data.code=="200"){
            var list = resp.data.data.BackPersonList.list||[];
            for(var i=0;i<list.length;i++){
              list[i].index = that.pageSize*(parseInt(that.currentPage)-1)+(i+1);
              list[i].overTemperature = parseFloat(list[i].backTemperature)>37.3?false:true
              list[i].comeProvinceName = list[i].comeProvinceName?list[i].comeProvinceName:'';
              list[i].comeCityName = list[i].comeCityName?list[i].comeCityName:'';
              list[i].comeAreaName = list[i].comeAreaName?list[i].comeAreaName:'';
            }
            that.listData = list;
            that.totalItems = resp.data.data.BackPersonList.total||0;
        }else{
          that.$message.error(resp.data.msg);
        }
      });
    },
  }
}
</script>

<style>
/* @import '../../../assets/css/admin/userMan.css'; */

</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content{
  height: 100%;
  background: #fff;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table{
  width: 100%;
  height: calc( 100% - 120px );
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar .el-button{
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}
.head-title{
  height:80px;
  border:0;
  padding-left:50px;
  display:flex;
  /* box-shadow: 3px 3px 6px 4px #ddd; */
  font-size: 20px;
  color: #2058D9;
  border-bottom: 10px solid #ecf0f5;
}
.el-pagination{
  padding: 15px 5px;
}
.flex-wrap{
  display: flex;
  flex-wrap: wrap;
}

</style>

<style>
.add-form .el-select .el-input{
  width: 100%;
}
.yiqing .el-select .el-input,.yiqing .el-cascader,.yiqing .el-input{
  width: 160px;
}
.yiqing .el-form-item{
  margin-bottom: 15px;
}
.yiqing .el-form-item__label{
    display: flex;
    height: 40px;
    line-height: 20px;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
}
.yiqing input::-webkit-input-placeholder {
  color: #606266;
}
</style>